var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPhoneIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09594 4.5C7.87861 4.5 7.59184 4.55584 7.28697 4.77468C7.26282 4.79279 4.79211 6.60085 4.79211 7.59091L4.79513 7.64977C4.90984 9.98757 6.6757 12.8793 10.0444 16.2479C13.4117 19.615 16.3035 21.3808 18.6413 21.497L18.6806 21.4985C18.6911 21.4985 18.7017 21.5 18.7123 21.5C19.7235 21.5 21.4999 19.0294 21.518 19.0052C21.9754 18.3638 21.8093 17.6469 21.3943 17.3511C21.1241 17.1474 18.2685 15.2774 17.9199 15.0692C17.5456 14.8548 17.0324 14.8956 16.5751 15.1703C16.3034 15.3182 15.4567 15.8026 15.0643 16.029C14.7142 15.7876 13.8569 15.1386 12.5212 13.7773C11.1809 12.4386 10.5184 11.5783 10.2663 11.2251C10.4942 10.8297 10.9772 9.98455 11.1296 9.70384C11.4028 9.20428 11.4345 8.68812 11.2141 8.3576C11.0179 8.0301 9.1132 5.13841 8.94114 4.89995C8.7872 4.68262 8.52458 4.53924 8.22423 4.50755C8.18499 4.50302 8.14273 4.5 8.09594 4.5Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPhoneIcons);
export default __webpack_public_path__ + "static/media/small-phone-icons.ea3d51790453ec277b1c7dd10b90f09a.svg";
export { ForwardRef as ReactComponent };